import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';

function Controller() {

    const { url_controller, url_method } = useParams();
    const stateApi = useSelector((state) => state.api); //Размеры окна

    // console.log('stateApi', stateApi)
    return (
        <>

            <h1>{stateApi.controllers.filter(a => a.Url_Controller == url_controller).length > 0 && stateApi.controllers.filter(a => a.Url_Controller == url_controller)[0].Name_Controller}</h1>

            {stateApi.menu.filter(a => a.Url_Controller == url_controller).map(item => (
                <Link key={item.ID_Method} to={"/api/" + item.Url_Controller + "/" + item.Url_Method}>
                    <div className='api_method_row'>
                        <div className='url'>
                            {item.Url_Method}
                            <div className={'http ' + item.Http_Method}>{item.Http_Method}</div>
                        </div>
                        <div className='name'>{item.Name_Method}</div>
                    </div>
                </Link>

            ))}


        </>
    );
}

export default Controller;
